import React from 'react';
import './About.css';

function Home() {
  return (
    <>
      <div
          className='aboutUs'
        >
          <div className='content'>
              <h2><span>Why</span>do you<br />need Us?</h2>
              <p>After giving extensive thought and research for over several weeks we realized that there is no platform that helps break into the "fintech world." <br/>Connecting with the required businesses is the key to our platform.</p>
              <a href='#'>Read more testimonials!</a>
          </div>
      </div>
    </>
  );
}

export default Home;